/* eslint-disable @typescript-eslint/no-explicit-any */
import {MIN_COTISATION} from '../../../data/constants/Assurance/assuranceRetraite';
import {defaultOrangeMoneyErrorValues} from '../../../data/constants/paiement';
import {MESSAGE_VALIDATION} from '../validation';

export const Validation = (contratEC: any, values: any) => {
  let errors: any = {...defaultOrangeMoneyErrorValues};

  if (values.montant == 0) {
    errors.montant = 'Veuillez entrer un montant non nul';
  }
  if (contratEC.typeContrat === undefined) {
    if (values.montant < MIN_COTISATION) {
      errors.montant = MESSAGE_VALIDATION.requiredCotisation;
    }
  }

  if (
    contratEC.typePayment === 'cotisation' &&
    contratEC.typeContratPayment === 'retraite'
  ) {
    if (+values.montant.toString().replace(/\s/g, '') < MIN_COTISATION) {
      errors.montant = MESSAGE_VALIDATION.requiredCotisation;
    }
  }

  /** checking all values */

  Object.entries(values).forEach(element => {
    if (element[1] === '' || element[1] === null) {
      if (element[0] !== 'dateEffet') {
        errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
      }
    }
  });

  return errors;
};
